const SupporterList = ({ data = [] }) => {
	if (!data || data.length === 0) {
		return null;
	}

	const sponsorList = data.map((sponsor, index) => {
		const {
			images: { sizes = {} },
			alt = '',
		} = sponsor;

		return (
			<span key={index} className={'cfs-supporters-media'}>
				<img
					alt={alt}
					src={sizes?.full?.url}
					height={sizes?.full?.height}
					width={sizes?.full?.width}
				/>
			</span>
		);
	});

	return (
		<div className="cfs-supporters">
			<span className="cfs-supporters-label">Powered by:</span>{' '}
			{sponsorList}{' '}
		</div>
	);
};

export default SupporterList;
